











































































































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
// @ts-ignore
import { Editor, EditorContent, EditorMenuBubble } from 'tiptap';
import {
  Blockquote,
  CodeBlock,
  HardBreak,
  Heading,
  HorizontalRule,
  OrderedList,
  BulletList,
  ListItem,
  TodoItem,
  TodoList,
  Bold,
  Code,
  Italic,
  Link,
  Table,
  TableHeader,
  TableCell,
  TableRow,
  Strike,
  Underline,
  History,
  TrailingNode,
  // @ts-ignore
} from 'tiptap-extensions';
@Component({
  components: {
    EditorContent,
    EditorMenuBubble,
  },
})
export default class UIEditor extends Vue {
  @Prop() readonly value: string;
  editor = null;
  keepInBounds = true;
  focus = false;
  emitAfterOnUpdate = false;
  mounted() {
    this.editor = new Editor({
      // @ts-ignore
      onUpdate: ({ getHTML }) => {
        this.emitAfterOnUpdate = true;
        this.$emit('input', getHTML());
      },
      content: this.value,
      extensions: [
        new Blockquote(),
        new BulletList(),
        new CodeBlock(),
        new HardBreak(),
        new Heading({ levels: [1, 2, 3] }),
        new HorizontalRule(),
        new ListItem(),
        new OrderedList(),
        new TodoItem(),
        new TodoList(),
        new Link(),
        new Table({
          resizable: true,
        }),
        new TableHeader(),
        new TableCell(),
        new TableRow(),
        new Bold(),
        new Code(),
        new Italic(),
        new Strike(),
        new Underline(),
        new History(),
        new TrailingNode({
          node: 'paragraph',
          notAfter: ['paragraph'],
        }),
      ],
    });
  }
  @Watch('value')
  onValueChange(val: string = '') {
    if (this.emitAfterOnUpdate) {
      this.emitAfterOnUpdate = false;
      return;
    }
    // @ts-ignore
    if (this.editor) this.editor.setContent(val, true);
  }
  beforeDestroy() {
    // @ts-ignore
    if (this.editor) this.editor.destroy();
  }
}
